import UserRegionInfo from "../utils/UserRegionInfo";
import { generateVodUrl } from "../utils/generateVodUrl";
import { ActionTypes as ScheduleActionTypes } from "./Schedule";

const VideoActionTypes = {
    HANDLE_VIDEO_API_RESPONSE: "HANDLE_VIDEO_API_RESPONSE",
    VIDEO_API_ERROR: "VIDEO_API_ERROR",
};

function loadStoryByBmmrId(videoStoryBmmrId, fetchOptions) {
    return (dispatch) => fetchStory(videoStoryBmmrId, dispatch, fetchOptions);
}

function loadCOJPStoryByBmmrId(videoStoryBmmrId, fetchOptions) {
    return (dispatch) =>
        fetchStory(videoStoryBmmrId, dispatch, {
            ...fetchOptions,
            isCOJP: true,
        });
}

function fetchStory(
    videoStoryBmmrId,
    dispatch,
    { isContinuousPlay = false, isCOJP = false } = {}
) {
    const region = UserRegionInfo.getRegion();

    return fetchDataByBmmrId(videoStoryBmmrId, { region }, isCOJP)
        .then(
            ({
                videoStory,
                schedule,
                relatedSeriesAndVideosData,
                recircShowModules,
            }) => {
                const referrer = window.location.href;
                setReferrer(referrer);

                window.history.replaceState(
                    null,
                    videoStory.headline.text,
                    generateVodUrl(videoStory.slug, isCOJP)
                );
                document.title = videoStory.headline.text;

                dispatch({
                    type: VideoActionTypes.HANDLE_VIDEO_API_RESPONSE,
                    data: {
                        videoStory,
                        referrer,
                        isContinuousPlay,
                        failedVideoBmmrId: null,
                        relatedSeriesAndVideosData,
                        recircShowModules,
                    },
                });

                dispatch({
                    type: ScheduleActionTypes.UPDATE_SCHEDULE_SUCCESS,
                    data: schedule.allSchedules,
                });
            }
        )
        .catch((error) => {
            console.error("Error fetching video data: ", error);
            dispatch({
                type: VideoActionTypes.VIDEO_API_ERROR,
                data: { failedVideoBmmrId: videoStoryBmmrId },
            });
        });
}

function fetchDataByBmmrId(bmmrId, { region }, isCOJP = false) {
    let url = `/multimedia/api/videos/bmmrid/${bmmrId}?region=${region}`;
    if (isCOJP) {
        url = `/jp/multimedia/api/videos/bmmrid/${bmmrId}?region=APAC`;
    }
    return fetch(url, {
        credentials: "same-origin",
    }).then((response) => {
        if (response.status >= 300) {
            throw new Error(`Invalid status code: ${response.status}`);
        }

        return response.json();
    });
}

// Abba-Client reads referrer from window.__bloomberg__.referrer and falls back to document.referrer
function setReferrer(referrer) {
    window.__bloomberg__ = window.__bloomberg__ || {};
    window.__bloomberg__.referrer = referrer;
}

export { loadStoryByBmmrId, loadCOJPStoryByBmmrId, VideoActionTypes };
